import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import confirm from 'modules/confirm';

import './DefaultColumnsButton.styles.scss';

type DefaultColumnsButtonProps = {
  className?: string;
  disabled?: boolean;
  onRestore: () => void;
};

const DefaultColumnsButton: React.FC<DefaultColumnsButtonProps> = (props) => {
  const { className, disabled, onRestore } = props;

  const classes = classNames('default-columns-button', className);

  const { t } = useTranslation();

  const handleOnClick = useCallback(async () => {
    if (
      await confirm({
        title: t('restoreDefaultColumnsTitle'),
        content: t('restoreDefaultColumnsMessage'),
        submitBtnText: t('restore'),
      })
    )
      onRestore();
  }, [onRestore, t]);

  return (
    <Button
      variant="link"
      className={classes}
      disabled={disabled}
      onClick={handleOnClick}
    >
      {t('defaultColumns')}
    </Button>
  );
};

export default DefaultColumnsButton;
